'use client'

import { useEffect } from 'react'
import type { ReactNode } from 'react'

import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import { store, persistor } from '@/redux-store'

if (process.env.NODE_ENV === 'development') {
  import('@/utils/cacheDebugUtils')
}

// Listener cross-tab: se outra aba dispara logout, força hard reload aqui também
// para garantir que nenhum estado em memória escape.
const CrossTabLogoutListener = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return

    const onStorage = (e: StorageEvent) => {
      if (e.key === '__vx_logout_signal__' && e.newValue) {
        const lang = window.location.pathname.split('/')[1] || 'pt'
        // Só redireciona se NÃO estiver já na tela de login (evita loop)
        if (!/\/login(\/|$)/.test(window.location.pathname)) {
          window.location.replace(`/${lang}/login`)
        }
      }
    }

    window.addEventListener('storage', onStorage)

    let channel: BroadcastChannel | null = null

    try {
      if (typeof BroadcastChannel !== 'undefined') {
        channel = new BroadcastChannel('vx_auth')

        channel.onmessage = event => {
          if (event?.data?.type === 'logout') {
            const lang = window.location.pathname.split('/')[1] || 'pt'

            if (!/\/login(\/|$)/.test(window.location.pathname)) {
              window.location.replace(`/${lang}/login`)
            }
          }
        }
      }
    } catch {
      // BroadcastChannel não suportado — storage event cobre
    }

    return () => {
      window.removeEventListener('storage', onStorage)

      try {
        channel?.close()
      } catch {
        // ignore
      }
    }
  }, [])

  return null
}

const ReduxProvider = ({ children }: { children: ReactNode }) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <CrossTabLogoutListener />
        {children}
      </PersistGate>
    </Provider>
  )
}

export default ReduxProvider
